import { gql } from '@apollo/client';

export const OBJECTIVE_QUERY = gql`
    query objective($objectiveId: UUID!) {
        objective(objectiveID: $objectiveId) {
            node {
                locales {
                    code,
                    name,
                    description
                }
                id
                createdAt
                updatedAt
                availableAt
                isPublished
                isRepeatable
                points
                credits
                badgeId
                publishAt
                unavailableAt
                availableAt
                maxEngagements
                isAvailable
                brandIds
                localeIds
                segmentIds
                revisionId
                productIds
                learningProfileIds
                companyRelationshipIds
                weight
                criteria {
                    id  
                    targetCount
                    targetValue
                    weight    
                    isEnabled 
                    criterionType {
                        id
                    }
                    locales {
                        code,
                        name,
                        description
                    }
                }
            }
        }
    }
`;
